import React from 'react'
import { Button, ListMenu, ListMenuButton, View } from 'oio-react'
import { MoreIcon } from 'assets/icons'
import { LAYOUT_BOX } from 'config/constants/ui'
import { homeEditUrl } from 'config/constants/urls'
import Popover from 'src/sites/kits/Utils/Popover'
import { useGlobalState } from 'src/sites/state'

const HomeMoreButton = () => {
   const { theme } = useGlobalState()
   const isBoxGL = theme.tmpGlobalLayout === LAYOUT_BOX

   return (
      <View
         position="fixed"
         bottom="0px"
         right="0px"
         paddingRight={theme.tmpViewportPadding}
         margin={isBoxGL ? '30px' : '30px 0px'}
         zIndex="2">
         <Popover.Provider>
            <Popover.Anchor>
               <Button
                  color="#eee"
                  rounded
                  size="sm"
                  width="30px">
                  <MoreIcon width="18px" height="18px" color="#444" />
               </Button>
            </Popover.Anchor>
            <Popover.View
               anchorOriginHorizontal="right"
               anchorOriginVertical="bottom"
               borderRadius="6px"
               width="220px">
               <View
                  float="left"
                  width="100%"
                  borderRadius="6px"
                  margin="12px 0px"
                  backgroundColor="#fff"
                  border="1px solid #eee"
                  boxShadow="6px 6px 30px rgba(0,0,0,0.1)">
                  <View float="left" width="100%">
                     <ListMenu buttonSize="sm">
                        <ListMenuButton
                           linkTo={homeEditUrl}
                           name="Edit Home Page"
                        />
                     </ListMenu>
                  </View>
               </View>
            </Popover.View>
         </Popover.Provider>
      </View>
   )
}

export default HomeMoreButton
